import { Component, OnInit, OnDestroy, ViewChild, HostListener, NgZone,  } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay, take, filter, switchMap } from 'rxjs/operators';
import { LocationStrategy, PlatformLocation, Location } from '@angular/common';
import {UserAccountService} from '../../../../core/services/user-account.service';
import { Group } from '../../models/group';
import {GroupService } from '../../services/group.service'
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogConfig, ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { AddGroupComponent } from '../../components/add-group/add-group-component';

@Component({
  standalone: false,
    selector: 'app-liste-groups',
    templateUrl: './liste-groups.component.html',
    styleUrls: ['./liste-groups.component.scss']
})
export class ListeGroupComponent implements OnInit, OnDestroy {
    // url: string;
    userData: any;
    displayedColumns: string[] = ['group', 'details', ];
    displayedColumnsName: string[] = ['Nom', '',  ''];
    tableOptions: any = {
      // "columnDefs": [ {
      //   "targets": 0,
      //   "render": this.renderStatusIcon
      // },
      // {
      //   "targets": 5,
      //   "render":this.renderTableActions
      // }
    // ]
    }
    dataSource: any;
    loading : boolean = false;
    states: any = {
      pending: {icon: 'pending'},
      running: {icon: 'expand_circle_down'},
      'shutting-down': {icon: 'do_not_disturb_on'},
      terminated:{icon: 'do_not_disturb_on'},
      stopping:{icon: 'do_not_disturb_on'},
      stopped: {icon: 'do_not_disturb_on'},
    }
    workspace_name: string | null = null;
    intervalId: any = 0;
    user_groups : string[] = []


    constructor(
      private readonly dialog_: MatDialog,
      private router: Router, location:Location,
      private breakpointObserver: BreakpointObserver,
      private userAccountService: UserAccountService,
      private groupsService: GroupService, private readonly ngZone_: NgZone) {
    }

    ngOnInit(): void {
      this.loading = true;
      this.groupsService.get()
          .subscribe(result => {
            this.dataSource = result;
            console.log(this.dataSource)
            this.loading = false;
          }
          );
    }


    ngOnDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }

    renderStatusIcon(data:string, type:any, row:any, meta:any ) {
      return data == 'running' ? '<mat-icon role="img" style="color: #1d8102;" class="mat-icon notranslate mat-tooltip-trigger material-icons mat-icon-no-color caaks-success" aria-hidden="true" data-mat-icon-type="font" aria-describedby="cdk-describedby-message-73" cdk-describedby-host="0"> fiber_manual_record </mat-icon>'
      : '<mat-icon role="img" class="mat-icon notranslate mat-tooltip-trigger material-icons mat-icon-no-color " aria-hidden="true" data-mat-icon-type="font" aria-describedby="cdk-describedby-message-73" cdk-describedby-host="0"> fiber_manual_record </mat-icon>';
    }

    getResourceStateDesc(state: string){
      return this.states[state]
    }


    isUserGrantedToEdit(instance: any){
      return true
    }

    handleAddGroupDialog(): void {
      const dialogData = {data: {}};
      const dialogDef = this.dialog_.open(AddGroupComponent, dialogData);
      dialogDef
        .afterClosed()
        .pipe(take(1))
        .subscribe(answer => {
          this.loading = true;
      this.groupsService.get()
          .subscribe(result => {
            this.dataSource = result;
            console.log(this.dataSource)
            this.loading = false;
          }
          );

        });
    }

    renderTableActions ( data: any, type:any, row:any, meta:any ) {
      if (data.state != 'running'){
        return '<button mat-icon-button matTooltip="Basic" aria-label="Démarrer cette ressource">\
        <span class="material-symbols-outlined">play_circle</span>\
        </button>'
      }

      return ''

    }

}
